import { VERSION } from './version';

export const environment: any = {
  production: true,
  envName: 'Production',
  version: VERSION,
  apiBaseUrl: 'https://api.webdespachantes.com.br/v1/site',
  hotJarTrackingCode: '1199827',
};
